module.exports = __webpack_public_path__ + "static/img/一种折叠花盆.0623ee4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert/一种折叠花盆.jpg
// module id = K7zr
// module chunks = 15